/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoileProjets, defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_038: Question = {
  id: 'pres-038-projets-restauration-milieux',
  oldId: '52',
  title: 'Réalisation de projets de restauration et/ou création de milieux humides et hydriques',
  number: '3.22',
  description: ['Nombre total de projets'],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data:number) => {
        if (data >= 7) return 3;
        if (data >= 3) return 2;
        if (data >= 1) return 1;
        return 0;
      },
      score: '0',
      maxScore: 3,
      help: etoileProjets,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

const question_pres_038__v3: Question = {
  ...question_pres_038,
  title: 'Réalisation de projets de restauration et/ou création de milieux naturels',
  number: '3.9',
  description: ['(hectares)'],
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.HECTARE,
    },
  ],
};

export const question_pres_038_v2: Question = question_pres_038;
export const question_pres_038_v3: Question = question_pres_038__v3;
